export default __webpack_public_path__ + "assets/where_is_my_debt_number_fr.svg";